import { CanActivate, Router, } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { ICurrentUser } from '../interfaces';
import { Observable, tap } from 'rxjs';

@Injectable()
export class AuthenticationGuardService implements CanActivate {
  constructor(
    @Inject('ICurrentUser') private currentUser: ICurrentUser,
    private router: Router) { }

  canActivate(): Observable<boolean> {
    return this.currentUser.isLoggedIn
      .pipe(tap(result => {
        if (result === false) {
          this.router.navigate(['/unauthorized']);
        }
      }));
  }
}
